exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".yn1XKjCb10c-xO{display:none;text-align:right;color:#5e6c84;margin-top:-8px}.yn1XKjCb10c-xO._1Cjl0WDcWktnee{display:block}", ""]);

// exports
exports.locals = {
	"lengthWarning": "yn1XKjCb10c-xO",
	"show": "_1Cjl0WDcWktnee"
};